import React, { useState, useEffect } from 'react'

const roles = ["逃走", "鬼"]

const TeamsTab = ({ teams, setTeams, members, setMembers, name, triggerAutoSave }) => {
    //チーム
    const [teamName, setTeamName] = useState("");
    const [teamRole, setTeamRole] = useState(0);
    const [teamScore, setTeamScore] = useState(0);
    const [teamColor, setTeamColor] = useState("#000000");
    const [teamMembers, setTeamMembers] = useState([]);
    const [focusTeam, setFocusTeam] = useState(null);
    const [editingTeam, setEditingTeam] = useState(null); // チーム表形式編集用

    //チームを追加
    const addTeam = () => {
        const newTeam = {
            name: teamName,
            score: Number(teamScore),
            role: teamRole,
            color: teamColor,
            members: teamMembers ? teamMembers : []
        }
        const teamID = focusTeam !== null ? focusTeam : teams.length;

        if(focusTeam === null) {
            setTeams((prev) => [
                ...prev,
                newTeam
            ])
        } else {
            setTeams((prev) => {
                const newTeams = [...prev];
                newTeams[focusTeam] = newTeam;
                return newTeams;
            })
        }

        //メンバーのデータに、チームIDを追加・削除
        setMembers((prev) => {
            const newMembers = [...prev];

            //削除
            newMembers.forEach((member, index) => {
                if(member.team === teamID && teamMembers.indexOf(index) === -1) {
                    member.team = null
                    // console.log(member.name + "を削除しました");
                };
            });

            //追加
            if(teamMembers) {
                teamMembers.forEach((index) => {
                    newMembers[index].team = teamID;
                });
            }
            // console.log(newMembers)
            return newMembers;
        });

        setTeamName("");
        setTeamRole(0);
        setTeamScore(0);
        setTeamColor("#000000");
        setTeamMembers([]);

        triggerAutoSave();
        console.log(teams)
    }

    //チームを削除
    const deleteTeam = (index) => {
        console.log("before members", members);
        console.log("before teams", teams);

        // チーム編集フォームの状態をリセット
        setFocusTeam(null);
        setTeamName("");
        setTeamRole(0);
        setTeamScore(0);
        setTeamColor("#000000");
        setTeamMembers([]);

        //メンバーのデータから、チームIDを削除し、他メンバーのチームIDのずれも補正
        setMembers((prev) => {
            const newMembers = [...prev];
            newMembers.forEach((member, i) => {
                if(member.team === index) {
                    member.team = null;
                } else if(Number(member.team) > index) {
                    member.team = Number(member.team) - 1; // チームIDが削除された場合、ずれを補正
                }
            });

            console.log("after members", newMembers);

            return newMembers;
        });

        // チームを削除
        setTeams((prev) => {
            const filteredTeams = prev.filter((team, i) => i !== index);
            console.log("after teams", filteredTeams);
            return filteredTeams;
        });

        triggerAutoSave();
    }

    //チームを編集
    // teamsをここで依存に含めると、他の変更によるteams更新のたびに編集中のフォームが上書きされてしまうため、
    // focusTeamが変化した（＝編集対象を選び直した）時のみ発火させる意図的な設計とする。
    useEffect(() => {
        if(focusTeam !== null) {
            setTeamName(teams[focusTeam].name);
            setTeamRole(teams[focusTeam].role);
            setTeamScore(teams[focusTeam].score);
            setTeamColor(teams[focusTeam].color);
            setTeamMembers(teams[focusTeam].members);
        } else {
            setTeamName("");
            setTeamRole(0);
            setTeamScore(0);
            setTeamColor("#000000");
            setTeamMembers([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [focusTeam]);

    // すべての参加者を、それぞれ1人チームとして追加
    const setTeamsOfOneMember = () => {
        const result = window.confirm('すべての参加者を、それぞれ1人チームとして設定しますか？');

        if(!result) return;

        const newTeams = [];
        members.forEach((member, index) => {
            newTeams.push({
                name: member.name,
                score: 0,
                role: 0,
                color: "#000000",
                members: [index]
            });
        });
        setTeams(newTeams);

        //メンバーのデータに、チームIDを追加
        setMembers((prev) => {
            const newMembers = [...prev];
            newMembers.forEach((member, i) => {
                member.team = i;
            });
            return newMembers;
        });

        triggerAutoSave();
    }

    // CSVファイルを解析してチームデータをインポートする
    const importTeamsCsv = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const csv = e.target.result;
                const lines = csv.split('\n').filter(line => line.trim() !== '');
                const newTeams = [];

                lines.forEach((line, index) => {
                    const columns = line.split(',').map(col => col.trim());

                    if (columns.length < 3) {
                        alert(`行 ${index + 1}: データが不足しています（最低3列必要）`);
                        return;
                    }

                    const teamName = columns[0];
                    const roleText = columns[1];
                    const scoreText = columns[2];
                    const colorText = columns[3] || '#000000';

                    // バリデーション
                    if (!teamName) {
                        alert(`行 ${index + 1}: チーム名が空です`);
                        return;
                    }

                    // 役割の変換（鬼/逃走 -> 1/0）
                    let role = 0;
                    if (roleText === '鬼') {
                        role = 1;
                    } else if (roleText === '逃走') {
                        role = 0;
                    } else {
                        alert(`行 ${index + 1}: 初期役は「鬼」または「逃走」で入力してください`);
                        return;
                    }

                    // スコアの変換
                    const score = parseInt(scoreText);
                    if (isNaN(score) || score < 0) {
                        alert(`行 ${index + 1}: 初期スコアは0以上の整数で入力してください`);
                        return;
                    }

                    // カラーの検証（簡易的な16進数チェック）
                    const color = colorText.startsWith('#') ? colorText : '#' + colorText;
                    if (!/^#[0-9A-Fa-f]{6}$/.test(color)) {
                        alert(`行 ${index + 1}: カラーは#000000形式で入力してください`);
                        return;
                    }

                    newTeams.push({
                        name: teamName,
                        role: role,
                        score: score,
                        color: color,
                        members: []
                    });
                });

                if (newTeams.length > 0) {
                    setTeams(prev => [...prev, ...newTeams]);
                    triggerAutoSave();
                    alert(`${newTeams.length}個のチームをインポートしました`);
                }
            } catch (error) {
                alert('CSVファイルの読み込みに失敗しました: ' + error.message);
            }
        };
        reader.readAsText(file);
    };

    // チームCSVファイルハンドラー
    const handleTeamCsvImport = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (!file.name.toLowerCase().endsWith('.csv')) {
            alert('CSVファイルを選択してください');
            return;
        }

        importTeamsCsv(file);
        // ファイル入力をリセット
        event.target.value = '';
    };

    // チームリストをCSV形式でエクスポートする
    const exportTeamsCsv = () => {
        try {
            // 各チームのメンバー数の最大値を求める
            const maxMemberCount = Math.max(...teams.map(team => {
                const teamMembers = members.filter(member => member.team === teams.indexOf(team));
                return teamMembers.length;
            }), 0);

            // CSVヘッダーを動的に作成
            const memberHeaders = Array.from({length: maxMemberCount}, (_, i) => `メンバー${i + 1}`).join(',');
            const csvHeader = `チームID,チーム名,初期役,スコア,カラー${maxMemberCount > 0 ? ',' + memberHeaders : ''}\n`;

            // チームデータをCSV形式に変換
            const csvData = teams.map((team, teamIndex) => {
                const teamId = teamIndex;
                const teamName = team.name || '';
                const role = team.role === 1 ? '鬼' : '逃走';
                const score = team.score || 0;
                const color = team.color || '#000000';

                // このチームのメンバーを取得
                const teamMembers = members.filter(member => member.team === teamIndex);
                const memberNames = teamMembers.map(member => member.name || '');

                // 不足分は空文字で埋める
                while (memberNames.length < maxMemberCount) {
                    memberNames.push('');
                }

                // CSVフィールドをエスケープ
                const escapeField = (field) => {
                    const fieldStr = String(field);
                    if (fieldStr.includes(',') || fieldStr.includes('\n') || fieldStr.includes('"')) {
                        return '"' + fieldStr.replace(/"/g, '""') + '"';
                    }
                    return fieldStr;
                };

                const baseFields = [
                    escapeField(teamId),
                    escapeField(teamName),
                    escapeField(role),
                    escapeField(score),
                    escapeField(color)
                ];

                const memberFields = memberNames.map(escapeField);

                return [...baseFields, ...memberFields].join(',');
            }).join('\n');

            // CSV全体のデータ
            const csvContent = csvHeader + csvData;

            // BOM付きUTF-8でエンコード（Excelで文字化けしないように）
            const bom = '﻿';
            const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });

            // ダウンロード用のリンクを作成
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', `チームリスト_${name || 'ゲーム'}_${new Date().toISOString().split('T')[0]}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            console.log(`${teams.length}チームのデータをCSVエクスポートしました`);
            alert('チームリストをCSVファイルでダウンロードしました');
        } catch (error) {
            console.error('CSV export error:', error);
            alert('CSVファイルの出力でエラーが発生しました');
        }
    };

    // チーム表形式での直接編集を保存
    const saveTeamTableEdit = (index, field, value) => {
        setTeams(prev => {
            const newTeams = [...prev];
            if (field === 'role') {
                newTeams[index] = { ...newTeams[index], role: Number(value) };
            } else if (field === 'score') {
                newTeams[index] = { ...newTeams[index], score: Number(value) || 0 };
            } else {
                newTeams[index] = { ...newTeams[index], [field]: value };
            }
            return newTeams;
        });
        triggerAutoSave();
    };

    return (
        <div className='mx-3'>
            {/* チーム管理ヘッダー */}
            <div className='rounded-lg bg-white p-3 mb-3 shadow-sm'>
                <h3 className='text-lg text-gray-800 mb-1'>チーム管理</h3>
                <p className='text-sm ms-2 text-gray-600'>
                    チーム情報を設定し、メンバーをチームに振り分けてください。<br/>
                    <strong>CSV形式:</strong> チーム名,初期役(鬼/逃走),初期スコア(0以上の整数),カラー(#000000形式、省略可)
                </p>
                <div className='flex gap-2 mt-3'>
                    <button
                        className='border border-purple-500 text-purple-500 px-3 py-1 rounded text-sm hover:bg-purple-50'
                        onClick={() => setTeamsOfOneMember()}
                    >
                        <i className='bi bi-person me-1'></i>全員１人チーム
                    </button>
                    <label className='border border-green-500 text-green-500 px-3 py-1 rounded text-sm hover:bg-green-50 cursor-pointer'>
                        <i className='bi bi-file-earmark-arrow-up me-1'></i>CSV インポート
                        <input
                            type="file"
                            accept=".csv"
                            onChange={handleTeamCsvImport}
                            className="hidden"
                        />
                    </label>
                    <button
                        onClick={exportTeamsCsv}
                        className='border border-blue-500 text-blue-500 px-3 py-1 rounded text-sm hover:bg-blue-50'
                        disabled={!teams || teams.length === 0}
                    >
                        <i className='bi bi-file-earmark-arrow-down me-1'></i>CSV エクスポート
                    </button>
                </div>
            </div>

            {/* チーム一覧表 */}
            <div className='rounded-lg bg-white shadow-sm overflow-hidden'>
                <div className='p-3 bg-gray-50 border-b'>
                    <h3 className='text-lg text-gray-800'>チーム一覧 ({teams ? teams.length : 0}チーム)</h3>
                </div>

                <div className='overflow-x-auto max-h-96 overflow-y-auto'>
                    <table className='w-full'>
                        <thead className='bg-gray-100 sticky top-0'>
                            <tr>
                                <th className='px-3 py-2 text-left text-sm font-medium text-gray-700 w-16'>ID</th>
                                <th className='px-3 py-2 text-left text-sm font-medium text-gray-700 w-32'>チーム名</th>
                                <th className='px-3 py-2 text-left text-sm font-medium text-gray-700 w-24'>初期役</th>
                                <th className='px-3 py-2 text-left text-sm font-medium text-gray-700 w-24'>初期スコア</th>
                                <th className='px-3 py-2 text-left text-sm font-medium text-gray-700 w-24'>カラー</th>
                                <th className='px-3 py-2 text-left text-sm font-medium text-gray-700'>メンバー</th>
                                <th className='px-3 py-2 text-center text-sm font-medium text-gray-700 w-20'>操作</th>
                            </tr>
                        </thead>
                        <tbody>
                            {teams.map((team, index) => {
                                const isEditing = editingTeam === index;
                                const teamMembers = members.filter(member => member.team === index);

                                return (
                                    <tr key={index} className='border-b hover:bg-gray-50'>
                                        {/* ID */}
                                        <td className='px-3 py-2'>
                                            <div className='text-sm font-mono text-gray-600'>{index}</div>
                                        </td>

                                        {/* チーム名 */}
                                        <td className='px-3 py-2'>
                                            {isEditing ? (
                                                <input
                                                    type="text"
                                                    value={team.name}
                                                    onChange={(e) => saveTeamTableEdit(index, 'name', e.target.value)}
                                                    className='w-full p-1 border rounded text-sm focus:outline-purple-300'
                                                />
                                            ) : (
                                                <div className='text-sm flex items-center'>
                                                    <i className='bi bi-people-fill me-2' style={{color: team.color}}></i>
                                                    {team.name}
                                                </div>
                                            )}
                                        </td>

                                        {/* 初期役 */}
                                        <td className='px-3 py-2'>
                                            {isEditing ? (
                                                <select
                                                    value={team.role}
                                                    onChange={(e) => saveTeamTableEdit(index, 'role', e.target.value)}
                                                    className='w-full p-1 border rounded text-sm focus:outline-purple-300'
                                                >
                                                    <option value={0}>逃走</option>
                                                    <option value={1}>鬼</option>
                                                </select>
                                            ) : (
                                                <div className='text-sm'>
                                                    {roles[team.role]}
                                                </div>
                                            )}
                                        </td>

                                        {/* 初期スコア */}
                                        <td className='px-3 py-2'>
                                            {isEditing ? (
                                                <input
                                                    type="number"
                                                    value={team.score}
                                                    onChange={(e) => saveTeamTableEdit(index, 'score', e.target.value)}
                                                    className='w-full p-1 border rounded text-sm focus:outline-purple-300'
                                                />
                                            ) : (
                                                <div className='text-sm flex items-center'>
                                                    <i className='bi bi-coin text-lime-500 me-1'></i>
                                                    <span className='font-bold'>{team.score}</span> pt
                                                </div>
                                            )}
                                        </td>

                                        {/* チームカラー */}
                                        <td className='px-3 py-2'>
                                            {isEditing ? (
                                                <input
                                                    type="color"
                                                    value={team.color}
                                                    onChange={(e) => saveTeamTableEdit(index, 'color', e.target.value)}
                                                    className='w-full h-8 border rounded focus:outline-purple-300'
                                                />
                                            ) : (
                                                <div className='flex items-center'>
                                                    <div
                                                        className='w-6 h-6 rounded border'
                                                        style={{backgroundColor: team.color}}
                                                    ></div>
                                                    <span className='ml-2 text-xs font-mono'>{team.color}</span>
                                                </div>
                                            )}
                                        </td>

                                        {/* メンバー */}
                                        <td className='px-3 py-2'>
                                            <div className='text-sm'>
                                                {teamMembers.length > 0 ? (
                                                    <div className='flex flex-wrap gap-1'>
                                                        {teamMembers.map((member, memberIndex) => (
                                                            <span
                                                                key={memberIndex}
                                                                className='bg-gray-100 px-2 py-0.5 rounded text-xs'
                                                            >
                                                                {member.name}
                                                            </span>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <span className='text-gray-400 text-xs'>メンバーなし</span>
                                                )}
                                            </div>
                                        </td>

                                        {/* 操作 */}
                                        <td className='px-3 py-2 text-center'>
                                            <div className='flex justify-center space-x-1'>
                                                {isEditing ? (
                                                    <button
                                                        onClick={() => setEditingTeam(null)}
                                                        className='text-green-600 hover:text-green-800 text-sm'
                                                        title="編集完了"
                                                    >
                                                        <i className='bi bi-check-lg'></i>
                                                    </button>
                                                ) : (
                                                    <button
                                                        onClick={() => setEditingTeam(index)}
                                                        className='text-blue-600 hover:text-blue-800 text-sm'
                                                        title="編集"
                                                    >
                                                        <i className='bi bi-pencil'></i>
                                                    </button>
                                                )}
                                                <button
                                                    onClick={() => deleteTeam(index)}
                                                    className='text-red-600 hover:text-red-800 text-sm'
                                                    title="削除"
                                                >
                                                    <i className='bi bi-trash'></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}

                            {/* 新規追加行 */}
                            <tr className='border-b bg-purple-50'>
                                <td className='px-3 py-2 text-center text-gray-400'>{teams.length}</td>
                                <td className='px-3 py-2'>
                                    <input
                                        type="text"
                                        value={teamName}
                                        onChange={(e) => setTeamName(e.target.value)}
                                        placeholder="新しいチーム名"
                                        className='w-full p-1 border rounded text-sm focus:outline-purple-300'
                                    />
                                </td>
                                <td className='px-3 py-2'>
                                    <select
                                        value={teamRole}
                                        onChange={(e) => setTeamRole(Number(e.target.value))}
                                        className='w-full p-1 border rounded text-sm focus:outline-purple-300'
                                    >
                                        <option value={0}>逃走</option>
                                        <option value={1}>鬼</option>
                                    </select>
                                </td>
                                <td className='px-3 py-2'>
                                    <input
                                        type="number"
                                        value={teamScore}
                                        onChange={(e) => setTeamScore(e.target.value)}
                                        placeholder="0"
                                        className='w-full p-1 border rounded text-sm focus:outline-purple-300'
                                    />
                                </td>
                                <td className='px-3 py-2'>
                                    <input
                                        type="color"
                                        value={teamColor}
                                        onChange={(e) => setTeamColor(e.target.value)}
                                        className='w-full h-8 border rounded focus:outline-purple-300'
                                    />
                                </td>
                                <td className='px-3 py-2'>
                                    <span className='text-xs text-gray-400'>追加後に設定</span>
                                </td>
                                <td className='px-3 py-2 text-center'>
                                    <div className='flex justify-center space-x-1'>
                                        <button
                                            onClick={() => addTeam()}
                                            className='text-green-600 hover:text-green-800 text-sm'
                                            title="追加"
                                        >
                                            <i className='bi bi-plus-lg'></i>
                                        </button>
                                        <button
                                            onClick={() => {
                                                setTeamName('');
                                                setTeamRole(0);
                                                setTeamScore('');
                                                setTeamColor('#000000');
                                            }}
                                            className='text-gray-600 hover:text-gray-800 text-sm'
                                            title="リセット"
                                        >
                                            <i className='bi bi-x-lg'></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default TeamsTab
